import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { TextInputComponent } from './text-input/text-input.component';
import { AlertComponent } from './alert/alert.component';
import { UploadAvatarImageComponent } from './upload-avatar-image/upload-avatar-image.component';
import { SubmitBtnComponent } from './submit-btn/submit-btn.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FileUploadModule } from 'ng2-file-upload';
import { LoaderListPlaceholderComponent } from './loader-list-placeholder/loader-list-placeholder.component';
import { DateFixPipe } from './pipes/date-fix.pipe';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TransferState } from '@angular/platform-browser';
import { TranslateBrowserLoader } from '../core/translate-browser.service';
import { UpgradeButtonComponent } from './upgrade-button/upgrade-button.component';
import { DropdownInputComponent } from './dropdown-input/dropdown-input.component';
import { LanguagePickerComponent } from './language-picker/language-picker.component';
import { RouterModule } from '@angular/router';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { DropdownInputV2Component } from './dropdown-input-v2/dropdown-input-v2.component';

export function createTranslateLoader(http: HttpClient, transferState: TransferState) {
  // return new TranslateHttpLoader(http, './assets/i18n-lang/', '.json');
  return new TranslateBrowserLoader(transferState, http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    FileUploadModule,
    BsDropdownModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient, TransferState]
      }
    })
  ],
  declarations: [
    LoaderComponent,
    TextInputComponent,
    AlertComponent,
    UploadAvatarImageComponent,
    LoaderListPlaceholderComponent,
    SubmitBtnComponent,
    DateFixPipe,
    UploadFileComponent,
    UpgradeButtonComponent,
    DropdownInputComponent,
    LanguagePickerComponent,
    PhoneInputComponent,
    DropdownInputV2Component
  ],
  exports: [
    LoaderComponent,
    TextInputComponent,
    AlertComponent,
    UploadAvatarImageComponent,
    LoaderListPlaceholderComponent,
    SubmitBtnComponent,
    DateFixPipe,
    UploadFileComponent,
    UpgradeButtonComponent,
    DropdownInputComponent,
    LanguagePickerComponent,
    PhoneInputComponent,
    DropdownInputV2Component
  ]
})
export class SharedWithClientModule { }
